import { useCallback } from 'react'
import { Customer } from '@typesApp/Session'
import { ActiveDataResult } from '@typesApp/ClaimRecord'
import { useSessionInfo } from '@hooks/useSessionInfo'
import { useLazyGetActiveClaimRecordQuery } from '@redux/queries/claimRecords'
import { isGatewayTimeout } from '@utils/errorUtil'

type UseActiveDataReturn = {
  fetchActiveData: (customer?: Customer) => Promise<ActiveDataResult>
}

export const useActiveData = (): UseActiveDataReturn => {
  const { customer: sessionCustomer } = useSessionInfo()
  const [fetchActive] = useLazyGetActiveClaimRecordQuery()

  const fetchActiveData = useCallback(
    async (customer?: Customer): Promise<ActiveDataResult> => {
      const customerNumber = customer?.id ?? sessionCustomer?.id
      if (!customerNumber) throw new Error('Customer number required to fetch active data!')

      try {
        return await fetchActive({ customerNumber }).unwrap()
      } catch (error) {
        if (isGatewayTimeout(error)) {
          return await fetchActive({ customerNumber }).unwrap()
        }
        throw error
      }
    },
    [sessionCustomer, fetchActive]
  )

  return {
    fetchActiveData,
  }
}
